module.exports = __webpack_public_path__ + "img/banner-04.bbc1bcb9.jpg";